// locale for calc

import safeLoadLocale from '@cdo/apps/util/safeLoadLocale';
import localeWithI18nStringTracker from '@cdo/apps/util/i18nStringTracker';

let locale = safeLoadLocale('calc_locale');
locale = localeWithI18nStringTracker(locale, 'calc');
module.exports = locale;
